// src/pages/onboarding/tools-choice.tsx
import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ListChecks, Search } from "lucide-react";

const toolOptions = [
  {
    title: "Analyze Keywords",
    description: "Review your keyword performance and quality scores.",
    icon: <ListChecks className="w-8 h-8 mb-4 text-primary" />,
    link: "/onboarding/keywords",
  },
  {
    title: "Analyze Search Terms",
    description:
      "See what users are actually searching for and find new opportunities.",
    icon: <Search className="w-8 h-8 mb-4 text-primary" />,
    link: "/onboarding/search-terms",
  },
];

const OnboardingToolsChoicePage = () => {
  return (
    <main className="flex-1 flex flex-col items-center justify-center p-4 space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold tracking-tight">
          Explore Your Account Data
        </h1>
        <p className="text-muted-foreground mt-2">
          Choose a simplified tool to start with.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-3xl">
        {toolOptions.map((option) => (
          <Link
            to={option.link}
            key={option.title}
            className="hover:scale-105 transform transition-transform duration-200"
          >
            <Card className="h-full flex flex-col items-center text-center p-6">
              {option.icon}
              <CardHeader className="p-0">
                <CardTitle>{option.title}</CardTitle>
              </CardHeader>
              <CardContent className="p-0 mt-2">
                <CardDescription>{option.description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </main>
  );
};

export default OnboardingToolsChoicePage;
